exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.backable.v-stepper__step--complete:hover .v-stepper__label {\n  text-decoration: underline;\n  cursor: pointer;\n}\n", ""]);

// exports
